<template>
    <section>
        <span
            style="
                position: absolute;
                background: yellow;
                z-index: 100;
                margin: 40px;
            "
            class="hidden"
            @click="setPlaybackIVS(playback_url)"
            >{{ playback_url }}
        </span>

        <div
            class="player-wrapper"
            no-click="setPlaybackIVS(playback_url)"
            :class="{ 'disabled-fullscreen': allow_fullscreen == 'no' }"
        >
            <div class="aspect-spacer"></div>
            <div
                class="pos-absolute full-width full-height top-0"
                id="videoContainer"
            >
                <div class="blocker"></div>
                <video
                    @click="stopFullscreen()"
                    :id="ivsID"
                    class="el-player stage-bg"
                    controls="1"
                    :controlsList="
                        'nodownload ' +
                        (allow_fullscreen == 'no' ? 'nofullscreen' : '')
                    "
                    autoplay
                    playsinline
                    disablepictureinpicture
                ></video>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    mounted() {
        Eventing.listen("start_ivs_stream", () =>
            this.setPlaybackIVS(this.playback_url)
        );

        let mql = window.matchMedia("(display-mode: fullscreen)");
    },
    created() {
        if (this.playback_url) {
            let that = this;
            // setTimeout(() => {
            //     that.setPlaybackIVS(that.playback_url);
            // }, 2000);
        }

        if (this.allow_fullscreen == "no") {
            try {
                document.addEventListener("fullscreenchange", (event) => {
                    // document.fullscreenElement will point to the element that
                    // is in fullscreen mode if there is one. If there isn't one,
                    // the value of the property is null.
                    if (document.fullscreenElement) {
                        alert(
                            "Om geen stemmigen te missen is het niet mogelijk om deze uitzending fullscreen te bekijken in uw browser.\nIn order not to miss any polls, it is not possible to view this broadcast fullscreen in your browser."
                        );
                        document.exitFullscreen();
                    } else {
                    }
                });
            } catch (error) {}

            var fullscreenElement =
                document.fullscreenElement ||
                document.mozFullScreenElement ||
                document.webkitFullscreenElement ||
                document.msFullscreenElement;
            if (fullscreenElement) {
                document.addEventListener("fullscreenChange", function () {
                    if (fullscreenElement != null) {
                        console.info("Went full screen");
                        fullscreenElement.exitFullscreen();
                    } else {
                        console.info("Exited full screen");
                    }
                });
            }
        }
    },
    props: {
        playback_url: {
            type: String,
            default: null,
        },
        ivsID: {
            type: String,
            default: "video-player",
        },
        allow_fullscreen: {
            type: String,
            default: "no",
        },
    },
    data() {
        return {
            player: null,
            stream: null,
        };
    },
    methods: {
        setPlaybackIVS(stream) {
            if (!this.stream) {
                this.strean = stream;
                this.initIVS(stream);
            }
        },
        initIVS(stream) {
            let self = this;
            try {
                (function (IVSPlayerPackage) {
                    if (!IVSPlayerPackage.isPlayerSupported) {
                        alert(
                            "The current browser does not support the IVS player."
                        );
                        return;
                    }
                    const PlayerState = IVSPlayerPackage.PlayerState;
                    const PlayerEventType = IVSPlayerPackage.PlayerEventType;

                    // Initialize player
                    const player = IVSPlayerPackage.create();
                    // IVSPlayerPackage.player.create()
                    console.log("IVS Player version:", player.getVersion());
                    player.attachHTMLVideoElement(
                        document.getElementById(self.ivsID)
                    );

                    // Attach event listeners
                    // player.addEventListener(PlayerState.PLAYING, function () {
                    //     console.log("Player State - PLAYING");
                    // });
                    // player.addEventListener(PlayerState.ENDED, function () {
                    //     console.log("Player State - ENDED");
                    // });
                    // player.addEventListener(PlayerState.READY, function () {
                    //     console.log("Player State - READY");
                    // });
                    // player.addEventListener(PlayerEventType.ERROR, function (err) {
                    //     console.warn("Player Event - ERROR:", err);
                    // });
                    player.addEventListener(
                        PlayerEventType.TEXT_METADATA_CUE,
                        (cue) => {
                            const metadataText = cue.text;
                            const position = player.getPosition().toFixed(2);
                            console.log(
                                `PlayerEvent - TEXT_METADATA_CUE: "${metadataText}". Observed ${position}s after playback started.`
                            );
                        }
                    );
                    // player.setLogLevel(DEBUG);
                    // Setup stream and play
                    player.setAutoplay(true);
                    player.setLiveLowLatencyEnabled(true);
                    player.load(stream);
                    player.setVolume(0.5);
                })(window.IVSPlayer);
            } catch (error) {
                console.warn(error);
            }
        },
        stopFullscreen() {
            if (this.allow_fullscreen == "no") {
                try {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitExitFullscreen) {
                        /* Safari */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        /* IE11 */
                        document.msExitFullscreen();
                    }
                } catch (error) {
                    console.log(error);
                }
                try {
                    document.webkitCancelFullScreen();
                } catch (error) {}
                try {
                    setTimeout(() => {
                        document.webkitCancelFullScreen();
                        document.webkitExitFullscreen();
                    }, 1000);
                } catch (error) {}
            }
        },
    },
    computed: {},
};
</script>
<style scoped>
.player-wrapper {
    width: 100%;
    position: relative;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    border-radius: 12px;
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.3);
    z-index: 1;
}

.aspect-spacer {
    padding-bottom: 56.25%;
}

.el-player {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background: white;
    border-radius: 12px;
}

.disabled-fullscreen #video-player:-webkit-full-screen {
    width: 10%;
    height: 10%;
}

video {
    width: 100%;
    border-radius: 12px;
    background: whitesmoke;
}

.disabled-fullscreen video::-webkit-media-controls-timeline,
.disabled-fullscreen video::-webkit-media-controls-current-time-display {
    display: none;
}

.disabled-fullscreen video::-webkit-media-controls-fullscreen-button {
    display: none !important;
}

.disabled-fullscreen .controls-bar.top-left {
    display: none !important;
}
.disabled-fullscreen .media-controls,
.disabled-fullscreen button.fullscreen,
.disabled-fullscreen .fullscreen {
    display: none !important;
    opacity: 0 !important;
    cursor: not-allowed;
    pointer-events: none;
}

.disabled-fullscreen .blocker {
    width: 60px;
    height: 60px;
    background: red;
    display: block;
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    opacity: 0;
}
</style>
